export const validateLocation = (formData) => {
  const errors = {};

  if (!formData.name?.trim()) errors.name = "Required";
  if (!formData.contactName?.trim()) errors.contactName = "Required";
  if (!formData.addressLine1?.trim()) errors.addressLine1 = "Required";
  if (!formData.city?.trim()) errors.city = "Required";
  if (!formData.state?.trim()) errors.state = "Required";

  if (!formData.phone?.trim()) {
    errors.phone = "Required";
  } else if (!/^[0-9]{10}$/.test(formData.phone)) {
    errors.phone = "10 Digits Required";
  }

  if (!formData.pincode?.trim()) {
    errors.pincode = "Required";
  } else if (!/^[0-9]{6}$/.test(formData.pincode)) {
    errors.pincode = "6 Digits Required";
  }

  return errors;
};
